import axios from "axios";
import config from '../config'

export function getSales() {
    let url = `${config.URL}/api/sales/get/5`;
    return axios.get(url)
        .then((response) => {
            return response.data.data;
        });
}